export const AuthUrls = {
  register: "/auth/register",
  login: "/auth/login",
  logout: "/auth/logout",
  forgotPassword: "/auth/forgot-password",
  resetPassword: "/auth/reset-password",
  profile: "/auth/profile",
};
export const RoleApiUrls = {
  list: (queryString) => `/roles?${queryString}`,
  create: "/roles",
  edit: (id) => `/roles/${id}`,
  delete: (id) => `/roles/${id}`,
};
export const UserApiUrls = {
  list: (queryString) => `/auth/users?${queryString}`,
  create: "/auth/users",
  edit: (id) => `/auth/users/${id}`,
  delete: (id) => `/auth/users/${id}`,
  deleteCards: (userId, id) => `/auth/cards?userId=${userId}&cardId=${id}`,
  savedCards: "/auth/users/cards",
  contact: "/auth/contact/",
};
export const FileApiUrls = {
  list: (queryString) => `/upload?${queryString}`,
  create: "/upload",
  createFolder: "/upload/folder",
  renameFolder: "/upload/folder",
  deleteFolder: (folderName) => `/upload/folder?folderName=${folderName}`,
  edit: (fileName) => `/upload/${fileName}`,
  delete: (fileName, folder) =>
    folder
      ? `/upload?folder=${folder}&filename=${fileName}`
      : `/upload?filename=${fileName}`,
};
export const TestApiUrls = {
  list: (queryString) => `/tests?${queryString}`,
  create: "/tests",
  edit: (id) => `/tests/${id}`,
  delete: (id) => `/tests/${id}`,
};
export const NewsApiUrls = {
  list: (queryString) => `/news?${queryString}`,
  single: (slug) => `/news/${slug}`,
  create: "/news",
  edit: (id) => `/news/${id}`,
  delete: (id) => `/news/${id}`,
};
export const BlogApiUrls = {
  list: (queryString) => `/blog?${queryString}`,
  single: (slug) => `/blog/${slug}`,
  create: "/blog",
  edit: (id) => `/blog/${id}`,
  delete: (id) => `/blog/${id}`,
};
export const ExamInfoApiUrls = {
  list: (queryString) => `/exam-info?${queryString}`,
  single: (slug) => `/exam-info/${slug}`,
  create: "/exam-info",
  edit: (id) => `/exam-info/${id}`,
  delete: (id) => `/exam-info/${id}`,
};
export const CategoryApiUrls = {
  list: `/category/`,
  listWithCourses: `/category/?showCourses=true`,
  edit: (id) => `/category/${id}`,
};
export const MaterialApiUrls = {
  list: (queryString) => `/materials?${queryString}`,
  create: "/materials",
  edit: (id) => `/materials/${id}`,
  delete: (id) => `/materials/${id}`,
};
export const StaticPageApiUrls = {
  // list: (queryString) => `/tests?${queryString}`,
  create: "/static",
  info: (slug) => `/static/${slug}`,
  edit: (slug) => `/static/${slug}`,
  delete: (id) => `/tests/${id}`,
};
export const staticHomeUrls = {
  home: "/static/home",
};
export const orderUrls = {
  create: "/order",
  edit: (id) => `/order/${id}`,
  payment: "/order/payment-success",
  purchases: (queryString) => `/order/purchases?${queryString}`,
  list: (queryString) => `/order?${queryString}`,
  userList: (id, queryString) => `/order/user/${id}?${queryString}`,
  promo: "/order/promo",
};
export const packageUrls = {
  list: (queryString) => `/package?${queryString}`,
  create: "/package",
  edit: (id) => `/package/${id}`,
  delete: (id) => `/package/${id}`,
};
export const subTopicUrls = {
  list: (queryString) => `/subtopic?${queryString}`,
  create: "/subtopic",
  edit: (id) => `/subtopic/${id}`,
  delete: (id) => `/subtopic/${id}`,
};
export const subchapterUrls = {
  list: (queryString) => `/subchapter?${queryString}`,
  create: "/subchapter",
  edit: (id) => `/subchapter/${id}`,
  single: (id) => `/subchapter/${id}`,
  delete: (id) => `/subchapter/${id}`,
};
export const subchapterQuestionUrls = {
  list: (queryString) => `/question?${queryString}`,
  create: "/question",
  edit: (id) => `/question/${id}`,
  delete: (id) => `/question/${id}`,
};
export const chapterUrls = {
  list: (queryString) => `/chapter?${queryString}`,
  create: "/chapter",
  edit: (id) => `/chapter/${id}`,
  single: (id) => `/chapter/${id}`,
  delete: (id) => `/chapter/${id}`,
};
export const modelTestUrls = {
  list: (queryString) => `/model-test?${queryString}`,
  create: "/model-test",
  edit: (id) => `/model-test/${id}`,
  editVisibility: (id) => `/model-test/visible/${id}`,
  delete: (id) => `/model-test/${id}`,
  createFreeModelTestTaker: `/free-model-test`,
  getFreeModelTestTaker: (queryString) => `/free-model-test?${queryString}`,
  getSingleFreeModelTestTaker: (id, queryString) =>
    queryString
      ? `/free-model-test/${id}?${queryString}`
      : `/free-model-test/${id}`,
  deleteFreeModelTestTaker: (id) => `/free-model-test/${id}`,
};
export const modelTestQuestionUrls = {
  list: (queryString) => `/model-test-question?${queryString}`,
  create: "/model-test-question",
  edit: (id) => `/model-test-question/${id}`,
  delete: (id) => `/model-test-question/${id}`,
  statusRoot: "/model-test-status",
  exam: (id) => `/model-test-status/${id}`,
  status: (id) => `/model-test-status/${id}`,
};
export const topicUrls = {
  list: (queryString) => `/topic?${queryString}`,
  create: "/topic",
  edit: (id) => `/topic/${id}`,
  delete: (id) => `/topic/${id}`,
};
export const liveClassSubsUrls = {
  list: (queryString) => `/live-class-subscription?${queryString}`,
  create: "/live-class-subscription",
  edit: (id) => `/live-class-subscription/${id}`,
  delete: (id) => `/live-class-subscription/${id}`,
};
export const liveClassItemsUrls = {
  list: (subscriptionId, queryString) =>
    `/live-class/${subscriptionId}?${queryString}`,
  create: (subscriptionId) => `/live-class/${subscriptionId}`,
  edit: (subscriptionId, id) => `/live-class/${subscriptionId}/${id}`,
  delete: (subscriptionId, id) => `/live-class/${subscriptionId}/${id}`,
};
